<template>
  <v-container class="root">
    <div class="btn-container">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn small class="btn-lang" v-on="on">
            {{ $t('label.language_setting') }}
          </v-btn>
        </template>
        <language-list />
      </v-menu>
    </div>
    <div class="msg-container">
      <img src="/images/cautionWithSmartphone.png" />
      <div
        v-for="n in [1, 2, 3, 4]" :key="n"
        class="msg"
        v-html="$t(`message.caution_${n}`)"
      />
    </div>
    <div class="btn-container">
      <v-btn
        v-if="visibleOkButton"
        class="btn-ok"
        :loading="loading"
        :disabled="loading"
        @click="onClickOK"
      >
        {{ $t('label.ok') }}
      </v-btn>
    </div>
    <error-dialog ref="errorDialog" />
  </v-container>
</template>

<script>
import LanguageList from '@/components/LanguageList'
import ErrorDialog from '@/components/ErrorDialog'
import Api from '@/lib/Api'
import Geo from '@/lib/Geo'

export default {
  name: 'Caution',
  components: {
    LanguageList,
    ErrorDialog
  },
  data () {
    return {
      stationDetail: null,
      geoPermissionOK: false,
      loading: false
    }
  },
  computed: {
    visibleOkButton () {
      return this.$route.name !== 'Root'
    }
  },
  methods: {
    onClickOK () {
      this.loading = true
      Api.getStationDetail('K22').then(detail => {
        this.stationDetail = detail
        const geo = window.navigator.geolocation
        if (geo) {
          geo.getCurrentPosition(this.onFetchPosition, this.onErrorPosition)
        } else {
          this.loading = false
          this.$refs.errorDialog.open('geolocation_disabled')
        }
      }).catch(err => {
        this.loading = false
        this.handleHttpError(err)
      })
    },
    onFetchPosition (position) {
      this.loading = false
      // const km = Geo.calcDistanceKm(this.stationDetail, position.coords)
      Api.getStationConfig('tomamu').then(config => {
        if (config) {
          const km = Geo.calcDistanceKm(config, position.coords)
          const distanceOK = (km < config.distance_threshold_km)
          this.$storage.set('distance_validated', distanceOK ? 'yes' : 'no')
          const nextRouteName = distanceOK ? 'Top' : 'Forbidden'
          this.$router.push({ name: nextRouteName })
        } else {
          this.handleHttpError()
        }
      }).catch(this.handleHttpError)
    },
    onErrorPosition (error) {
      this.loading = false
      let msgId = (error.code === 1) ? 'geolocation_permission_denied' : 'geolocation_failed'
      this.$refs.errorDialog.open(msgId)
    },
    handleHttpError (err) {
      window.console.log(err)
      this.$refs.errorDialog.open('error_message.api_failed_to_get_station_detail')
    },
    goToTop () {
      this.$router.push({ name: 'Top' })
    }
  }
}
</script>

<style lang="scss" scoped>
.root {
  padding-top: 0;
}
.btn-container {
  width: 100%;
  text-align: right;
}
.btn-lang {
  text-transform: none;
}
.msg-container {
  background-color: white;
  border-radius: 8px;
  padding: 8px;
  img {
    display: block;
    width: 100%;
  }
  .msg {
    padding-top: 8px;
    color: darkred;
    font-size: 16px;
    text-align: center;
  }
}
.btn-ok {
  font-size: 18px;
  color: #0D47A1;
  font-weight: bold;
}
</style>
